<div class="d-flex align-items-center">
  <span class="lead fs-6">{{ message?.['timestamp'] | date:'short' }} </span>
  @if(message?.['state'] === 'unread'){
  <span class="badge bg-secondary ms-2 text-uppercase">{{ 'si_pts_chrome_message_header_unread' | cmsText | async }}</span>
  }
  @else if(message?.['state'] === 'new'){
  <span class="badge bg-primary ms-2 text-uppercase">{{ 'si_pts_chrome_message_header_new' | cmsText | async }}</span>
  }
</div>
<h6 class="mt-1 mb-1">{{ message?.['heading'] }}</h6>
